import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

/**
 * Robustly waits for Firebase Auth to initialize and return the current user.
 */
export const waitForFirebaseAuth = () => (new Promise((resolve) => {
  const { auth } = firebase;
  if (auth().currentUser) {
    resolve(auth().currentUser);
  } else {
    const unsubscribe = auth().onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user || null);
    });
    
    // Safety timeout
    setTimeout(() => {
      resolve(auth().currentUser || null);
    }, 8000);
  }
}));
